import { Component } from '@angular/core';

@Component({
  selector: 'app-profile-navigation-1',
  templateUrl: 'profile-navigation.component.html'
})
export class ProfileNavigation1Component {

}
